import React, {useState} from 'react';
import HeaderDropdown from "../dropdown";
import HeaderButton from "../button";
import RepresentationModal from "./representationModal";
import './styles.scss';
import {toast} from "react-toastify";

const Representation = ({value, setValue, options, columns, save, loading, onDelete}) => {
    const initModalData = {
        open: false,
        representation: null
    };
    const [modalData, setModalData] = useState(initModalData)

    const valueFromOptions = (value) => {
        return value ? (options || []).find(o => o.value === value).data : null
    }

    return (
        <div className='header-btns'>
            <HeaderDropdown
                options={options}
                icon='table'
                value={(value || {}).id}
                withLeftLine
                onChange={(e, {value}) => setValue(valueFromOptions(value))}
            />
            <HeaderButton
                icon='settings'
                name='Настройка данных'
                withLeftLine
                onClick={() => setModalData({
                    open: true,
                    representation: value
                })}
                disabled={(value || {}).isReadOnly}
            />
            <HeaderButton
                icon='plus-new'
                name='Создать новый отчет'
                withLeftLine
                onClick={() => setModalData({
                    open: true
                })}
            />
            <RepresentationModal
                loading={loading}
                columns={columns}
                open={modalData.open}
                representation={modalData.representation}
                onClose={() => setModalData(initModalData)}
                onSave={(d) => {
                    if ((options || []).filter(o => d.id ? (o.value !== d.id) : true).map(o => o.text).includes(d.name)) {
                        toast.error('Такое название отчета уже есть. Пожалуйста, переименуйте отчет')
                    } else if (!(d.columns || []).length) {
                        toast.error('Пожалуйста, добавьте хотя бы одно поле в данные вашего отчета')
                    } else {
                        save(d);
                        setModalData(initModalData);
                    }
                }}
                onDelete={onDelete}
            />
        </div>
    );
};

export default Representation;


// WEBPACK FOOTER //
// ./App/pages/reports/components/representation/representation.jsx